import { render, staticRenderFns } from "./LoginDetailsTeachers.vue?vue&type=template&id=1985f096&"
import script from "./LoginDetailsTeachers.vue?vue&type=script&lang=js&"
export * from "./LoginDetailsTeachers.vue?vue&type=script&lang=js&"
import style0 from "./LoginDetailsTeachers.vue?vue&type=style&index=0&id=1985f096&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports